var _defs, _rect, _line, _line2, _line3, _line4, _polygon, _polygon2, _polygon3, _polygon4, _circle, _circle2, _circle3, _circle4, _g, _g2, _g3, _g4, _g5, _text;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvg2Pipeline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 760 200",
    xmlns: "http://www.w3.org/2000/svg",
    width: 760,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n    @keyframes stage-on{0%,100%{filter:none;opacity:.5}50%{filter:url(#p-glow);opacity:1}}\n    @keyframes flow-dot{0%{offset-distance:0%;opacity:0}5%{opacity:1}95%{opacity:1}100%{offset-distance:100%;opacity:0}}\n    @keyframes label-pulse{0%,100%{fill:#475569}50%{fill:#e2e8f0}}\n    .s1{animation:stage-on 5s ease-in-out infinite 0s}\n    .s2{animation:stage-on 5s ease-in-out infinite 1s}\n    .s3{animation:stage-on 5s ease-in-out infinite 2s}\n    .s4{animation:stage-on 5s ease-in-out infinite 3s}\n    .s5{animation:stage-on 5s ease-in-out infinite 4s}\n    .l1{animation:label-pulse 5s ease-in-out infinite 0s}\n    .l2{animation:label-pulse 5s ease-in-out infinite 1s}\n    .l3{animation:label-pulse 5s ease-in-out infinite 2s}\n    .l4{animation:label-pulse 5s ease-in-out infinite 3s}\n    .l5{animation:label-pulse 5s ease-in-out infinite 4s}\n  "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p-bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#060912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0a0f1e"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "p-glow",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "b"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "b"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "p1",
    d: "M 167 100 L 197 100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p2",
    d: "M 317 100 L 347 100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p3",
    d: "M 467 100 L 497 100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p4",
    d: "M 617 100 L 647 100"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 760,
    height: 200,
    fill: "url(#p-bg)",
    rx: 20
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 167,
    y1: 100,
    x2: 197,
    y2: 100,
    stroke: "#1e293b",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 317,
    y1: 100,
    x2: 347,
    y2: 100,
    stroke: "#1e293b",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 467,
    y1: 100,
    x2: 497,
    y2: 100,
    stroke: "#1e293b",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 617,
    y1: 100,
    x2: 647,
    y2: 100,
    stroke: "#1e293b",
    strokeWidth: 2
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "197,95 207,100 197,105",
    fill: "#1e293b"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#1e293b;#38bdf8;#1e293b",
    dur: "5s",
    repeatCount: "indefinite",
    begin: "0.5s"
  }))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "347,95 357,100 347,105",
    fill: "#1e293b"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#1e293b;#a78bfa;#1e293b",
    dur: "5s",
    repeatCount: "indefinite",
    begin: "1.5s"
  }))), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "497,95 507,100 497,105",
    fill: "#1e293b"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#1e293b;#34d399;#1e293b",
    dur: "5s",
    repeatCount: "indefinite",
    begin: "2.5s"
  }))), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "647,95 657,100 647,105",
    fill: "#1e293b"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#1e293b;#fb923c;#1e293b",
    dur: "5s",
    repeatCount: "indefinite",
    begin: "3.5s"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    fill: "#38bdf8"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "5s",
    repeatCount: "indefinite",
    begin: ".2s"
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#p1"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;0;1;1;0;0;0;0;0;0",
    keyTimes: "0;.03;.05;.09;.11;1",
    dur: "5s",
    repeatCount: "indefinite",
    begin: ".2s"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    fill: "#a78bfa"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "5s",
    repeatCount: "indefinite",
    begin: "1.2s"
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#p2"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;0;1;1;0;0;0;0;0;0",
    keyTimes: "0;.03;.05;.09;.11;1",
    dur: "5s",
    repeatCount: "indefinite",
    begin: "1.2s"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    fill: "#34d399"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "5s",
    repeatCount: "indefinite",
    begin: "2.2s"
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#p3"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;0;1;1;0;0;0;0;0;0",
    keyTimes: "0;.03;.05;.09;.11;1",
    dur: "5s",
    repeatCount: "indefinite",
    begin: "2.2s"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    fill: "#fb923c"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "5s",
    repeatCount: "indefinite",
    begin: "3.2s"
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#p4"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;0;1;1;0;0;0;0;0;0",
    keyTimes: "0;.03;.05;.09;.11;1",
    dur: "5s",
    repeatCount: "indefinite",
    begin: "3.2s"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "s1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 60,
    width: 140,
    height: 80,
    rx: 12,
    fill: "#0a1628",
    stroke: "#38bdf8",
    strokeWidth: 1.5,
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: ".4;1;.4",
    dur: "5s",
    repeatCount: "indefinite",
    begin: "0s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    values: ".3;1;.3",
    dur: "5s",
    repeatCount: "indefinite",
    begin: "0s"
  })), /*#__PURE__*/React.createElement("text", {
    x: 97,
    y: 91,
    textAnchor: "middle",
    fill: "#38bdf8",
    fontFamily: "JetBrains Mono",
    fontSize: 18
  }, "\uD83D\uDCCA"), /*#__PURE__*/React.createElement("text", {
    x: 97,
    y: 110,
    textAnchor: "middle",
    fontFamily: "JetBrains Mono",
    fontSize: 9,
    className: "l1"
  }, "Data Collection"), /*#__PURE__*/React.createElement("text", {
    x: 97,
    y: 124,
    textAnchor: "middle",
    fill: "#1e3a5f",
    fontFamily: "JetBrains Mono",
    fontSize: 8
  }, "01"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "s2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 207,
    y: 60,
    width: 110,
    height: 80,
    rx: 12,
    fill: "#0a1628",
    stroke: "#a78bfa",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    values: ".3;1;.3",
    dur: "5s",
    repeatCount: "indefinite",
    begin: "1s"
  })), /*#__PURE__*/React.createElement("text", {
    x: 262,
    y: 91,
    textAnchor: "middle",
    fill: "#a78bfa",
    fontFamily: "JetBrains Mono",
    fontSize: 18
  }, "\uD83E\uDDE0"), /*#__PURE__*/React.createElement("text", {
    x: 262,
    y: 110,
    textAnchor: "middle",
    fontFamily: "JetBrains Mono",
    fontSize: 9,
    className: "l2"
  }, "Personalize"), /*#__PURE__*/React.createElement("text", {
    x: 262,
    y: 124,
    textAnchor: "middle",
    fill: "#1e3a5f",
    fontFamily: "JetBrains Mono",
    fontSize: 8
  }, "02"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "s3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 357,
    y: 60,
    width: 110,
    height: 80,
    rx: 12,
    fill: "#0a1628",
    stroke: "#34d399",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    values: ".3;1;.3",
    dur: "5s",
    repeatCount: "indefinite",
    begin: "2s"
  })), /*#__PURE__*/React.createElement("text", {
    x: 412,
    y: 91,
    textAnchor: "middle",
    fill: "#34d399",
    fontFamily: "JetBrains Mono",
    fontSize: 18
  }, "\u23F0"), /*#__PURE__*/React.createElement("text", {
    x: 412,
    y: 110,
    textAnchor: "middle",
    fontFamily: "JetBrains Mono",
    fontSize: 9,
    className: "l3"
  }, "Usage Time"), /*#__PURE__*/React.createElement("text", {
    x: 412,
    y: 124,
    textAnchor: "middle",
    fill: "#1e3a5f",
    fontFamily: "JetBrains Mono",
    fontSize: 8
  }, "03"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "s4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 507,
    y: 60,
    width: 110,
    height: 80,
    rx: 12,
    fill: "#0a1628",
    stroke: "#fb923c",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    values: ".3;1;.3",
    dur: "5s",
    repeatCount: "indefinite",
    begin: "3s"
  })), /*#__PURE__*/React.createElement("text", {
    x: 562,
    y: 91,
    textAnchor: "middle",
    fill: "#fb923c",
    fontFamily: "JetBrains Mono",
    fontSize: 18
  }, "\u2699\uFE0F"), /*#__PURE__*/React.createElement("text", {
    x: 562,
    y: 110,
    textAnchor: "middle",
    fontFamily: "JetBrains Mono",
    fontSize: 9,
    className: "l4"
  }, "Scheduler"), /*#__PURE__*/React.createElement("text", {
    x: 562,
    y: 124,
    textAnchor: "middle",
    fill: "#1e3a5f",
    fontFamily: "JetBrains Mono",
    fontSize: 8
  }, "04"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "s5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 657,
    y: 60,
    width: 80,
    height: 80,
    rx: 12,
    fill: "#0a1628",
    stroke: "#f472b6",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    values: ".3;1;.3",
    dur: "5s",
    repeatCount: "indefinite",
    begin: "4s"
  })), /*#__PURE__*/React.createElement("text", {
    x: 697,
    y: 91,
    textAnchor: "middle",
    fill: "#f472b6",
    fontFamily: "JetBrains Mono",
    fontSize: 18
  }, "\uD83D\uDE80"), /*#__PURE__*/React.createElement("text", {
    x: 697,
    y: 110,
    textAnchor: "middle",
    fontFamily: "JetBrains Mono",
    fontSize: 9,
    className: "l5"
  }, "Deliver"), /*#__PURE__*/React.createElement("text", {
    x: 697,
    y: 124,
    textAnchor: "middle",
    fill: "#1e3a5f",
    fontFamily: "JetBrains Mono",
    fontSize: 8
  }, "05"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 380,
    y: 175,
    textAnchor: "middle",
    fill: "#1e293b",
    fontFamily: "JetBrains Mono",
    fontSize: 10,
    letterSpacing: 2
  }, "NOTIFICATION PIPELINE \u2014 EACH STAGE ACTIVATES IN SEQUENCE")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg2Pipeline);
export default __webpack_public_path__ + "static/media/svg2-pipeline.5781ea788c4789c991bb195dcf699bbf.svg";
export { ForwardRef as ReactComponent };